<!-- 
component: DatePicker.vue
author: Takumi Ogura
description: 日付入力フォーム
repletion: 返却値はYYYY/MM-DD形式の文字列
-->
<template>
	<v-text-field
		ref="textField"
		id="dateField"
		solo
		v-model="pickerText"
		label="年月日"
		clearable
		@click:clear="clear()"
		@blur="inputDate()"
		hide-details
		:background-color="active ? 'grey lighten-1' : ''"
		:disabled="active"
	>
	</v-text-field>
</template>
<script>
import Const from '../common/constants.js'
export default {
	props:{
		tabIdx:{
			type: Number,
			default: -1,
		},
		active:{
			type: Boolean,
			default: false,
		}
	},
	data(){
		return {
			menu: false,
			picker: '',
			pickerText: '',
			minValue: Const.datepickerMinValue,
		}
	},
	mounted(){
	},
	computed: {
	},
	methods: {
		// テキストボックスからデートピッカーへ値を挿入
		convertJapaneseDateToGregorian(japaneseDate) {
			// 和暦の年、月、日を抽出する
			var parts = japaneseDate.match(/([SHR])(\d{1,2})年(\d{1,2})月(\d{1,2})日/);
			var era = parts[1];
			var year = parts[2].padStart(2, '0');
			var month = parts[3].padStart(2, '0'); // 1桁の月を2桁に変換する
			var day = parts[4].padStart(2, '0'); // 1桁の日を2桁に変換する

			// S391108形式に変換して返す
			return era + year + month + day;
		},
		inputDate() {
			if(!this.pickerText) return null

			if(this.pickerText.indexOf("年") !== -1) {
				this.pickerText = this.convertJapaneseDateToGregorian(this.pickerText);
				//return;
			}

			const letters = this.pickerText.charAt(0); // "S"
			const numbers = this.pickerText.slice(1).match(/\d{2}/g).map(Number); // ["39", "11", "08"]

			var start_year = 0;
			if(letters == "T") {
				start_year = 1912;
			} else if (letters == "S") {
				start_year = 1926;
			} else if (letters == "H") {
				start_year = 1989;
			} else if (letters == "R") {
				start_year = 2019;
			} else {
				this.inputDate_toWareki();
				return;
			}

			if(this.pickerText.length != 7)  {
				alert("日付の入力を確認してください:"+this.pickerText);
				this.pickerText ="";
				return;
			}

			var year = start_year+numbers[0]-1;
			var month = numbers[1];
			var day = numbers[2];

			const date = new Date(year, month-1, day);
			if(date.getFullYear() !== year ||
           date.getMonth() !== month - 1 ||
           date.getDate() !== day) {
				alert("日付の入力を確認してください:"+this.pickerText);
				//this.pickerText ="";
				return;
			}

			month = ('00' + month).slice(-2);
			day = ('00' + day).slice(-2);
			this.picker = `${year}-${month}-${day}`;

			this.$emit('input', this.picker);
			//this.$refs.cnfStartDate.pickerText = this.pickerText; // uke_dayに和暦を反映させる
			this.menu = false;

			const wareki = this.convertToWareki(year, month, day);
			const warekiYear = parseInt(year) - wareki.startYear + 1;
			this.pickerText = `${wareki.era}${warekiYear}年${month}月${day}日`;
		},
		inputDate_toWareki() {
			if(!this.pickerText) return null
			let [year, month, day] = this.pickerText.split('-');
			if (typeof month === 'undefined' || month === '') {
				return;
			}
			if (typeof day === 'undefined' || day === '') {
				return;
			}
			month = ('00' + month).slice(-2);
			day = ('00' + day).slice(-2);
			this.picker = `${year}-${month}-${day}`;

			const wareki = this.convertToWareki(year, month, day);
			const warekiYear = parseInt(year) - wareki.startYear + 1;
			this.pickerText = `${wareki.era}${warekiYear}年${month}月${day}日`;

			this.$emit('input', this.picker);
			//this.$refs.cnfStartDate.pickerText = this.pickerText; // uke_dayに和暦を反映させる
			this.menu = false;
		},
		// デートピッカーからテキストボックスへ値を挿入
//		formatDate (date) {
//			if (!date) return null
//			const [year, month, day] = date.split('-');
//			const wareki = this.convertToWareki(year);
//			const warekiYear = parseInt(year) - wareki.startYear + 1;
//			this.pickerText = `${wareki.era}${warekiYear}年${month}月${day}日`;
//			this.menu = false;
////			this.$emit('input',this.pickerText);
//			this.$emit('input',date);
//		},
		convertToWareki(year, month, day) {
			// 令和：2019年5月1日以降
			if (year >= 2019) {
				return { era: 'R', startYear: 2019 };
			} else if (year >= 1989) {
				if (year == 1989 && month == 1 && day <= 7) {
					return { era: 'S', startYear: 1926 };
				} else {
					return { era: 'H', startYear: 1989 };
				}
			} else if (year >= 1926) {
				return { era: 'S', startYear: 1926 };
			} else if (year >= 1912) {
				return { era: 'T', startYear: 1912 };
			} else {
				return { era: 'M', startYear: 1868 };
			}
		},
		clear() {
			this.picker = null;
			this.$attrs.value = null;
			this.$emit('clear', '');
		},
		focus() {
			const datePickerTextField = this.$refs.textField;
			datePickerTextField.focus();
//			datePickerTextField.$el.focus();
		},
	}
}
</script>
<style>
.datepicker {
	height: 375px;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
}
</style>